// -------------------------------------------------------------------------------

// PLEASE DO NOT EDIT THIS FILE, IT IS GENERATED AND WILL BE OVERWRITTEN:
// https://github.com/ccxt/ccxt/blob/master/CONTRIBUTING.md#how-to-contribute-code

// -------------------------------------------------------------------------------

import { implicitReturnType } from '../../base/types.js';
import { default as _Exchange } from '../../base/PredictionExchange.js';

interface Exchange {
    gammaPublicGetStatus (params?: {}): Promise<implicitReturnType>;
    gammaPublicGetComments (params?: {}): Promise<implicitReturnType>;
    gammaPublicGetCommentsId (params?: {}): Promise<implicitReturnType>;
    gammaPublicGetCommentsUserAddressUserAddress (params?: {}): Promise<implicitReturnType>;
    gammaPublicGetEvents (params?: {}): Promise<implicitReturnType>;
    gammaPublicGetEventsCreators (params?: {}): Promise<implicitReturnType>;
    gammaPublicGetEventsCreatorsId (params?: {}): Promise<implicitReturnType>;
    gammaPublicGetEventsKeyset (params?: {}): Promise<implicitReturnType>;
    gammaPublicGetEventsPagination (params?: {}): Promise<implicitReturnType>;
    gammaPublicGetEventsResults (params?: {}): Promise<implicitReturnType>;
    gammaPublicGetEventsSlugSlug (params?: {}): Promise<implicitReturnType>;
    gammaPublicGetEventsId (params?: {}): Promise<implicitReturnType>;
    gammaPublicGetEventsIdCommentsCount (params?: {}): Promise<implicitReturnType>;
    gammaPublicGetEventsIdTags (params?: {}): Promise<implicitReturnType>;
    gammaPublicGetEventsIdTweetCount (params?: {}): Promise<implicitReturnType>;
    gammaPublicGetMarkets (params?: {}): Promise<implicitReturnType>;
    gammaPublicGetMarketsKeyset (params?: {}): Promise<implicitReturnType>;
    gammaPublicGetMarketsSlugSlug (params?: {}): Promise<implicitReturnType>;
    gammaPublicGetMarketsId (params?: {}): Promise<implicitReturnType>;
    gammaPublicGetMarketsIdDescription (params?: {}): Promise<implicitReturnType>;
    gammaPublicGetMarketsIdTags (params?: {}): Promise<implicitReturnType>;
    gammaPublicGetProfilesUserAddressUserAddress (params?: {}): Promise<implicitReturnType>;
    gammaPublicGetPublicProfile (params?: {}): Promise<implicitReturnType>;
    gammaPublicGetPublicSearch (params?: {}): Promise<implicitReturnType>;
    gammaPublicGetSeries (params?: {}): Promise<implicitReturnType>;
    gammaPublicGetSeriesSummarySlugSlug (params?: {}): Promise<implicitReturnType>;
    gammaPublicGetSeriesSummaryId (params?: {}): Promise<implicitReturnType>;
    gammaPublicGetSeriesId (params?: {}): Promise<implicitReturnType>;
    gammaPublicGetSeriesIdCommentsCount (params?: {}): Promise<implicitReturnType>;
    gammaPublicGetSports (params?: {}): Promise<implicitReturnType>;
    gammaPublicGetSportsMarketTypes (params?: {}): Promise<implicitReturnType>;
    gammaPublicGetTags (params?: {}): Promise<implicitReturnType>;
    gammaPublicGetTagsSlugSlug (params?: {}): Promise<implicitReturnType>;
    gammaPublicGetTagsSlugSlugRelatedTags (params?: {}): Promise<implicitReturnType>;
    gammaPublicGetTagsSlugSlugRelatedTagsTags (params?: {}): Promise<implicitReturnType>;
    gammaPublicGetTagsId (params?: {}): Promise<implicitReturnType>;
    gammaPublicGetTagsIdRelatedTags (params?: {}): Promise<implicitReturnType>;
    gammaPublicGetTagsIdRelatedTagsTags (params?: {}): Promise<implicitReturnType>;
    gammaPublicGetTeams (params?: {}): Promise<implicitReturnType>;
    gammaPublicGetTeamsId (params?: {}): Promise<implicitReturnType>;
    gammaPublicPostMarketsAbridged (params?: {}): Promise<implicitReturnType>;
    gammaPublicPostMarketsInformation (params?: {}): Promise<implicitReturnType>;
    clobPublicGetBook (params?: {}): Promise<implicitReturnType>;
    clobPublicGetBooks (params?: {}): Promise<implicitReturnType>;
    clobPublicGetBuilderTrades (params?: {}): Promise<implicitReturnType>;
    clobPublicGetClobMarketsConditionId (params?: {}): Promise<implicitReturnType>;
    clobPublicGetFeeRate (params?: {}): Promise<implicitReturnType>;
    clobPublicGetFeeRateTokenId (params?: {}): Promise<implicitReturnType>;
    clobPublicGetLastTradePrice (params?: {}): Promise<implicitReturnType>;
    clobPublicGetLastTradesPrices (params?: {}): Promise<implicitReturnType>;
    clobPublicGetMarketsByTokenTokenId (params?: {}): Promise<implicitReturnType>;
    clobPublicGetMarketsLiveActivityConditionId (params?: {}): Promise<implicitReturnType>;
    clobPublicGetMidpoint (params?: {}): Promise<implicitReturnType>;
    clobPublicGetMidpoints (params?: {}): Promise<implicitReturnType>;
    clobPublicGetNegRisk (params?: {}): Promise<implicitReturnType>;
    clobPublicGetNegRiskTokenId (params?: {}): Promise<implicitReturnType>;
    clobPublicGetPrice (params?: {}): Promise<implicitReturnType>;
    clobPublicGetPrices (params?: {}): Promise<implicitReturnType>;
    clobPublicGetPricesHistory (params?: {}): Promise<implicitReturnType>;
    clobPublicGetRebatesCurrent (params?: {}): Promise<implicitReturnType>;
    clobPublicGetRewardsMarketsCurrent (params?: {}): Promise<implicitReturnType>;
    clobPublicGetRewardsMarketsMulti (params?: {}): Promise<implicitReturnType>;
    clobPublicGetRewardsMarketsConditionId (params?: {}): Promise<implicitReturnType>;
    clobPublicGetSamplingMarkets (params?: {}): Promise<implicitReturnType>;
    clobPublicGetSamplingSimplifiedMarkets (params?: {}): Promise<implicitReturnType>;
    clobPublicGetSimplifiedMarkets (params?: {}): Promise<implicitReturnType>;
    clobPublicGetSpread (params?: {}): Promise<implicitReturnType>;
    clobPublicGetTickSize (params?: {}): Promise<implicitReturnType>;
    clobPublicGetTickSizeTokenId (params?: {}): Promise<implicitReturnType>;
    clobPublicGetTime (params?: {}): Promise<implicitReturnType>;
    clobPublicPostBatchPricesHistory (params?: {}): Promise<implicitReturnType>;
    clobPublicPostBooks (params?: {}): Promise<implicitReturnType>;
    clobPublicPostLastTradesPrices (params?: {}): Promise<implicitReturnType>;
    clobPublicPostMarketsLiveActivity (params?: {}): Promise<implicitReturnType>;
    clobPublicPostMidpoints (params?: {}): Promise<implicitReturnType>;
    clobPublicPostPrices (params?: {}): Promise<implicitReturnType>;
    clobPublicPostSpreads (params?: {}): Promise<implicitReturnType>;
    clobPrivateGetAuthApiKeys (params?: {}): Promise<implicitReturnType>;
    clobPrivateGetAuthBanStatusClosedOnly (params?: {}): Promise<implicitReturnType>;
    clobPrivateGetAuthBuilderApiKey (params?: {}): Promise<implicitReturnType>;
    clobPrivateGetAuthDeriveApiKey (params?: {}): Promise<implicitReturnType>;
    clobPrivateGetBalanceAllowance (params?: {}): Promise<implicitReturnType>;
    clobPrivateGetBalanceAllowanceUpdate (params?: {}): Promise<implicitReturnType>;
    clobPrivateGetDataOrderId (params?: {}): Promise<implicitReturnType>;
    clobPrivateGetDataOrders (params?: {}): Promise<implicitReturnType>;
    clobPrivateGetDataTrades (params?: {}): Promise<implicitReturnType>;
    clobPrivateGetNotifications (params?: {}): Promise<implicitReturnType>;
    clobPrivateGetOrderScoring (params?: {}): Promise<implicitReturnType>;
    clobPrivateGetOrdersScoring (params?: {}): Promise<implicitReturnType>;
    clobPrivateGetRewardsUser (params?: {}): Promise<implicitReturnType>;
    clobPrivateGetRewardsUserMarkets (params?: {}): Promise<implicitReturnType>;
    clobPrivateGetRewardsUserPercentages (params?: {}): Promise<implicitReturnType>;
    clobPrivateGetRewardsUserTotal (params?: {}): Promise<implicitReturnType>;
    clobPrivatePostAuthApiKey (params?: {}): Promise<implicitReturnType>;
    clobPrivatePostAuthBuilderApiKey (params?: {}): Promise<implicitReturnType>;
    clobPrivatePostHeartbeats (params?: {}): Promise<implicitReturnType>;
    clobPrivatePostOrder (params?: {}): Promise<implicitReturnType>;
    clobPrivatePostOrders (params?: {}): Promise<implicitReturnType>;
    clobPrivatePostV1Heartbeats (params?: {}): Promise<implicitReturnType>;
    clobPrivateDeleteAuthApiKey (params?: {}): Promise<implicitReturnType>;
    clobPrivateDeleteAuthBuilderApiKey (params?: {}): Promise<implicitReturnType>;
    clobPrivateDeleteCancelAll (params?: {}): Promise<implicitReturnType>;
    clobPrivateDeleteCancelMarketOrders (params?: {}): Promise<implicitReturnType>;
    clobPrivateDeleteNotifications (params?: {}): Promise<implicitReturnType>;
    clobPrivateDeleteOrder (params?: {}): Promise<implicitReturnType>;
    clobPrivateDeleteOrders (params?: {}): Promise<implicitReturnType>;
    dataPublicGetActivity (params?: {}): Promise<implicitReturnType>;
    dataPublicGetClosedPositions (params?: {}): Promise<implicitReturnType>;
    dataPublicGetHolders (params?: {}): Promise<implicitReturnType>;
    dataPublicGetLiveVolume (params?: {}): Promise<implicitReturnType>;
    dataPublicGetOi (params?: {}): Promise<implicitReturnType>;
    dataPublicGetOther (params?: {}): Promise<implicitReturnType>;
    dataPublicGetPositions (params?: {}): Promise<implicitReturnType>;
    dataPublicGetRevisions (params?: {}): Promise<implicitReturnType>;
    dataPublicGetTraded (params?: {}): Promise<implicitReturnType>;
    dataPublicGetTrades (params?: {}): Promise<implicitReturnType>;
    dataPublicGetV1AccountingSnapshot (params?: {}): Promise<implicitReturnType>;
    dataPublicGetV1ActivityCombos (params?: {}): Promise<implicitReturnType>;
    dataPublicGetV1BuildersLeaderboard (params?: {}): Promise<implicitReturnType>;
    dataPublicGetV1BuildersVolume (params?: {}): Promise<implicitReturnType>;
    dataPublicGetV1Leaderboard (params?: {}): Promise<implicitReturnType>;
    dataPublicGetV1MarketPositions (params?: {}): Promise<implicitReturnType>;
    dataPublicGetV1PositionsCombos (params?: {}): Promise<implicitReturnType>;
    dataPublicGetValue (params?: {}): Promise<implicitReturnType>;
    combosPublicGetV1RfqComboMarkets (params?: {}): Promise<implicitReturnType>;
    combosPrivatePostV1MakerConfirmations (params?: {}): Promise<implicitReturnType>;
    combosPrivatePostV1MakerQuotes (params?: {}): Promise<implicitReturnType>;
    combosPrivatePostV1MakerQuotesCancel (params?: {}): Promise<implicitReturnType>;
}
abstract class Exchange extends _Exchange {}

export default Exchange
